import React from "react";
import "./AddOrderForm.css";
import img from "./imgs/logo_black.png";
import OrderCategoriesField from "./OrderCategoriesField";

const AddOrderForm = ({
  formData,
  errors,
  isSubmitting,
  onChange,
  onCategoriesChange,
  onSubmit,
  title = "إضافة طلب جديد",
  submitLabel = "إضافة الطلب",
  submittingLabel = "جارٍ الطلب...",
  showPriority = true
}) => {
  return (
    <div className="add-container">
        <form onSubmit={onSubmit} className="add-box">
          <img src={img} alt="logo" className="add-logo" width="200px" />

          <h2>{title}</h2>

          {showPriority && (
            <div className="input-group full-width priority-center">
              <label>أولوية (مهم)</label>
              <label className="toggle">
                <input
                  type="checkbox"
                  name="priority"
                  checked={!!formData.priority}
                  onChange={onChange}
                />
                <span className="toggle-slider" />
                <span className="toggle-text">
                  {formData.priority ? "مفعلة" : "غير مفعلة"}
                </span>
              </label>
            </div>
          )}
          <div className="input-group">
            <label>الاسم الكامل</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={onChange}
              placeholder="ادخل الاسم هنا"
            />
            {errors.name && <small className="error-text">{errors.name}</small>}
          </div>

          <div className="input-group">
            <label>رقم الهاتف</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={onChange}
              placeholder="09XXXXXXXX"
            />
            {errors.phone && <small className="error-text">{errors.phone}</small>}
          </div>

          <div className="input-group">
            <label>الموقع</label>
            <input
              type="text"
              name="location"
              value={formData.location}
              onChange={onChange}
              placeholder="ادخل الموقع هنا"
            />
            {errors.location && <small className="error-text">{errors.location}</small>}
          </div>

          <OrderCategoriesField
            categories={formData.categories}
            error={errors.categories}
            onChange={onCategoriesChange}
            groupClassName="input-group full-width"
          />
          <div className="input-group">
            <label>الموقع على الخريطة</label>
            <input
              type="text"
              name="locationOnMap"
              value={formData.locationOnMap}
              onChange={onChange}
              rows="1"
              placeholder="رابط الموقع على خرائط جوجل (اختياري)"
            />
          </div>
          <div className="input-group full-width">
            <label>ملاحظات</label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={onChange}
              rows="4"
              placeholder="تفاصيل إضافية (اختياري)"
            />
          </div>

          <button type="submit" className="add-btn" disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                <span className="loading"></span> {submittingLabel}
              </>
            ) : (
              submitLabel
            )}
          </button>
        </form>
      
    </div>
  );
};

export default AddOrderForm;
